import axios from "axios";
import decode from "jwt-decode";
import { createRef, useEffect, useReducer, useState } from "react";
import { config as url } from "../../common/config";
import {
	AUTH_ERROR,
	CLEAR_ERROR,
	LOGIN_FAIL,
	LOGIN_SUCCESS,
	LOGOUT,
	USER_LOADED,
} from "../types";
import AuthContext from "./authContext";
import authReducer from "./authReducer";

const AuthState = (props) => {
	const initialState = {
		token: localStorage.getItem("token"),
		user: null,
		tableRef: createRef(),
		tableRefCompare: createRef(),
		error: null,
	};
	const [state, dispatch] = useReducer(authReducer, initialState);

	const [stateLogoImages, setStateLogoImages] = useState();

	const loadLogoImages = async () => {
		const config = {
			headers: {
				"Content-Type": "application/json",
				Authentication: localStorage.token,
			},
		};
		try {
			const res = await axios.get(`${url.login}/identitas`, config);
			setStateLogoImages(res.data?.data);
			return res.data;
		} catch (error) {
			dispatch({ type: AUTH_ERROR });
		}
	};

	const loadUserInfo = async () => {
		const config = {
			headers: {
				"Content-Type": "application/json",
				Authentication: localStorage.token,
			},
		};
		try {
			const decoded = decode(localStorage.getItem("token"));
			if (decoded.exp < Date.now() / 1000) {
				return dispatch({ type: AUTH_ERROR });
			}
			const res = await axios.get(`${url.users}/info?id=${decoded.id}`, config);
			const { data } = res.data;
			dispatch({
				type: USER_LOADED,
				payload: {
					user: data,
				},
			});
		} catch (error) {
			dispatch({ type: AUTH_ERROR });
		}
	};

	const login = async (formData) => {
		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		try {
			const res = await axios.post(`${url.login}`, formData, config);
			const { status, data, message } = res.data;
			if (status === "error") {
				return dispatch({
					type: LOGIN_FAIL,
					payload: {
						token: data.token,
						message: message,
					},
				});
			}
			dispatch({
				type: LOGIN_SUCCESS,
				payload: {
					user: data.token,
				},
			});
			loadUserInfo();
		} catch (err) {
			dispatch({
				type: LOGIN_FAIL,
				payload: err.response ? err.response.data.message : err.message,
			});
		}
	};

	const logout = () => {
		dispatch({ type: LOGOUT });
	};
	// CHECK TOKEN IF EXPIRED
	const isTokenExpired = () => {
		const decoded = decode(localStorage.token);
		if (decoded.exp < Date.now() / 1000) {
			return dispatch({ type: AUTH_ERROR });
		}
	};

	const token = localStorage.getItem("token");

	// LOGIN FAILED
	const clearFailed = () => dispatch({ type: CLEAR_ERROR });

	//TimeOut if user mouse not move
	useEffect(() => {
		if (token) {
			let timeoutHandle = setTimeout(() => {
				logout();
				window.location.reload();
			}, 6000000);

			document.onmousemove = () => {
				clearTimeout(timeoutHandle);
				timeoutHandle = setTimeout(() => {
					logout();
					window.location.reload();
				}, 6000000);
			};
		}
		// eslint-disable-next-line
	}, [token]);

	return (
		<AuthContext.Provider
			value={{
				token: state.token,
				user: state.user,
				error: state.error,
				tableRef: state.tableRef,
				tableRefCompare: state.tableRefCompare,
				login,
				logout,
				loadUserInfo,
				loadLogoImages,
				isTokenExpired,
				clearFailed,
				stateLogoImages,
			}}
		>
			{props.children}
		</AuthContext.Provider>
	);
};

export default AuthState;
